import { scrollToTop } from '../utils/scrollUtils';

export default {
    scrollToTop(smooth = true) {
        return scrollToTop(smooth);
    }
}